// import React from "react";
// import {
//   MDBCarousel,
//   MDBCarouselItem,
//   MDBCol,
//   MDBRow,
// } from "mdb-react-ui-kit";

import React from "react";
import {
  MDBCarousel,
  MDBCarouselItem,
  MDBCol,
  MDBIcon,
  MDBTypography,
  MDBContainer,
  MDBRow,
} from "mdb-react-ui-kit";
import man1 from "../media/man1.jpg";
import man2 from "../media/man2.jpg";
import fm1 from "../media/fm1.jpg";
import fm2 from "../media/fm2.jpg";
import fm3 from "../media/fm3.jpg";

export default function App() {
  return (
    <MDBContainer className="py-5">
      <MDBCarousel showControls dark>
        <MDBCarouselItem className="active">
          <MDBContainer>
            <MDBRow className="text-center">
              <MDBCol lg="4" className="mb-5 mb-md-0">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={fm1}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">Laura G</h5>
               
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>¡Increíble experiencia!</b> Publiqué lo que quería comer y el
                  cooker preparó todo exactamente como lo imaginé. La comida
                  estaba deliciosa y el precio fue muy bueno. ¡Recomiendo mucho
                  Cheffy!
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
              <MDBCol lg="4" className="d-none d-lg-block">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={man1}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">Carlos M</h5>
                
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>¡Súper práctico!</b> Llegué cansado del trabajo y no tenía ganas
                  de cocinar. Usé Cheffy y, en unas horas, tenía una cena casera
                  fresca en mi casa. Perfecto para días ocupados.
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star-half-alt"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
              <MDBCol lg="4" className="d-none d-lg-block">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={fm2}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">AnaL</h5>
              
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>Gran relación calidad-precio.</b> Pedí a un chef que preparara platos para la semana, y las porciones eran generosas y sabrosas. Me ahorré mucho tiempo y esfuerzo.
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      far
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </MDBCarouselItem>
        <MDBCarouselItem>
          <MDBContainer>
            <MDBRow className="text-center">
            <MDBCol lg="4" className="d-none d-lg-block">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={man2}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">Juan P</h5>
              
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>Me encanta la idea.</b> Es como tener un restaurante en casa, pero
                  más personalizado y a un precio justo. Además, el proceso fue
                  muy fácil y seguro.
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      far
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
              <MDBCol lg="4" className="mb-5 mb-md-0">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={fm3}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">María T</h5>
               
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>¡Perfecto para eventos pequeños!</b> Contratamos un chef para una
                  cena con amigos, y todos quedaron encantados con la calidad de
                  la comida y la atención. Fue todo un éxito.
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
              <MDBCol lg="4" className="mb-5 mb-md-0">
                <div className="d-flex justify-content-center mb-4">
                  <img
                    src={fm1}
                    className="rounded-circle shadow-1-strong"
                    width="150"
                    height="150"
                  />
                </div>
                <h5 className="mb-3">Laura G</h5>
               
                <p className="px-xl-3">
                  <MDBIcon fas icon="quote-left" className="pe-2" />
                  <b>¡Increíble experiencia!</b> Publiqué lo que quería comer y el
                  cooker preparó todo exactamente como lo imaginé. La comida
                  estaba deliciosa y el precio fue muy bueno. ¡Recomiendo mucho
                  Cheffy!
                </p>
                <MDBTypography
                  listUnStyled
                  className="d-flex justify-content-center mb-0"
                >
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                  <li>
                    <MDBIcon
                      fas
                      icon="star"
                      size="sm"
                      className="text-warning"
                    />
                  </li>
                </MDBTypography>
              </MDBCol>
             
            </MDBRow>
          </MDBContainer>
        </MDBCarouselItem>
      </MDBCarousel>
    </MDBContainer>
  );
}
